import type { ColDef } from "ag-grid-community";
import { themeAlpine } from "ag-grid-community";
import { styled } from "@mui/material";
import Stack from "@mui/material/Stack";
import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";

import { theme } from "@src/theme";

export const sharedTableTheme = themeAlpine.withParams({
  fontFamily: theme.typography.fontFamily,
  fontSize: "14px",
});

export const SharedTableCard = styled(Stack)(({ theme }) => ({
  border: `1px solid ${theme.igBorders.core.default}`,
  borderRadius: "8px",
  backgroundColor: theme.igBackgroundColors.baseLightLow,
  overflow: "hidden",
}));

export const sharedTableGridSx: SystemStyleObject<Theme> = {
  "& .ag-header": {
    borderBottom: (theme) =>
      `1px solid ${theme.igBorders.core.disabled} !important`,
  },
  "& .ag-row": {
    borderBottom: (theme) =>
      `1px solid ${theme.igBorders.core.disabled} !important`,
  },
  "& .ag-header-cell-text": {
    color: "text.placeholder",
    fontWeight: 500,
    textTransform: "uppercase",
    fontSize: "10px",
  },
  "& .ag-header-row.ag-header-row-column": {
    backgroundColor: "background.paper",
  },
  "& .ag-header-cell-label": {
    justifyContent: "flex-start !important",
    marginRight: "0 !important",
  },
  "& .ag-header-cell, & .ag-cell": {
    borderRight: "none !important",
  },
  "--ig-grid-frame-color": "transparent",
};

export const createSharedTableDefaultColDef = <TRow,>(
  settings: ColDef<TRow> = {},
  cellStyle: ColDef<TRow>["cellStyle"] = {}
): ColDef<TRow> => ({
  flex: 1,
  minWidth: 120,
  resizable: false,
  sortable: false,
  menuTabs: [],
  suppressMovable: true,
  suppressHeaderMenuButton: true,
  cellStyle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    ...cellStyle,
  },
  ...settings,
});
